import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

export function fadeAnimation(transitionTime: number): AnimationTriggerMetadata {
  return trigger('fade', [
    state('void', style({ opacity: 0, visibility: 'hidden' })),
    state('*', style({ opacity: 1, visibility: 'visible' })),
    transition('* <=> void', animate(transitionTime)),
  ]);
}

export function fadeVerticallyAnimation(transitionTime: number): AnimationTriggerMetadata {
  return trigger('fadeVertically', [
    transition(':enter', [
      style({ opacity: 0, visibility: 'hidden', height: '0', margin: '0' }),
      animate(transitionTime, style({ opacity: 0, visibility: 'hidden', height: '*', margin: '*' })),
      animate(transitionTime, style({ opacity: 1, visibility: 'visible', height: '*', margin: '*' })),
    ]),
    transition(':leave', [
      style({ opacity: 1, visibility: 'visible', height: '*', margin: '*' }),
      animate(transitionTime, style({ opacity: 0, visibility: 'hidden', height: '*', margin: '*' })),
      animate(transitionTime, style({ opacity: 0, visibility: 'hidden', height: '0', margin: '0' })),
    ]),
  ]);
}

export function fadeAnimationWithState(transitionTime: number | string): AnimationTriggerMetadata {
  return trigger('fadeState', [
    state('in', style({ opacity: 1, visibility: 'visible' })),
    state('out', style({ opacity: 0, visibility: 'hidden' })),
    state('void', style({ opacity: 0, visibility: 'hidden' })),
    transition('* <=> *', animate(transitionTime)),
  ]);
}
